import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
    selector: '[appMax]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxValidatorDirective, multi: true }],
    standalone: false
})
export class MaxValidatorDirective  implements Validator {
  // Bind the maximum value from the template
  @Input('appMax') max: number = 0;

  validate(control: AbstractControl): ValidationErrors | null {
    if (control.value) {
      const value = parseFloat(control.value);
      // If the value is a number and exceeds the maximum, return an error object
      if (!isNaN(value) && value > this.max) {
        return { 'max': { value: control.value, max: this.max } };
      }
    }
    return null;
  }
}
